<template>
    <div class="v2_info-popup__body">
        <b-row class="mt-2 submitted-survey-container">
            <b-col cols="12">
                <template>
                    <p class="mt-2">
                        You’ve asked Phairify to keep an eye out for job opportunities matching 
                        the specific terms of your ICO, below. Take a moment to confirm, edit, 
                        or replace this ICO to make sure we’re promoting to the market 
                        the exact job terms you want to hear about.
                    </p>
                </template>
            </b-col>
        </b-row>
        <b-row class="mt-2 submitted-survey-container">
            <b-col cols="12">
                <template>
                    <desired-prior-job-question
                            v-for="(jQ, index) in defaultQuestionData"
                            :key="`djq_${jQ.id}_${index}`"
                            :job-question="jQ"
                    >
                    <span slot="right-section" class="select-icon-wrapper">
                        <p class="clickable" style="font-size: 0.875rem">
                        </p>
                    </span>
                    </desired-prior-job-question>
                </template>
            </b-col>
            <!-- <b-col cols="8" class="d-flex py-2">
                <table class="table">
                    <template>
                        <tbody>
                            <tr>
                                <td>Location</td>
                                <td>{{ locationDisplayName }}</td>
                            </tr>
                            <template  v-if="defaultQuestionData">
                            <tr v-for="que in defaultQuestionData" :key="que.question.id">
                                <template  v-if="que.question.job_question_id"> 
                                    <td>{{ que.question.label }}</td>
                                    <td v-if="que.question.relatedJobQuestion != null">
                                        <template v-if="que.question.type=='SLIDER'">
                                            {{ (que.question.relatedJobQuestion) ? `${que.question.firstVariable.prefix ? que.question.firstVariable.prefix : ''} ${formatValue(que.question.relatedJobQuestion.response_default_value)}` : '' }}
                                        </template>
                                        <template v-else>
                                            {{ (que.question.relatedJobQuestion) ? `${que.question.firstVariable.prefix ? que.question.firstVariable.prefix : ''}  ${que.question.relatedJobQuestion.response_default_value}` : '' }}
                                        </template>
                                    </td>
                                </template>
                            </tr>
                            </template>
                        </tbody>
                    </template>
                </table>
            </b-col> -->
        </b-row>
        <b-row>
            <b-col cols="12" class="d-flex py-2">
                <b-button
                        class="mx-3 review-ico-btn"
                        variant="v3_teal_outline"
                        @click="goToDashBoard"
                >
                        I still want this job
                </b-button>
                </b-col>
                <b-col cols="12" class="d-flex py-2">
                        <b-button
                                class="mx-3 submit-button review-ico-btn"
                                variant="v3_teal_outline"
                                @click="icoInEditMode"
                        >
                        I want this job but with some changes
                        </b-button>
                </b-col>
                <b-col cols="12" class="d-flex py-2">
                        <b-button
                                class="mx-3 submit-button review-ico-btn"
                                variant="v3_teal_outline"
                                @click="createNewIcoMode"
                        >
                        My goals have changed – I want another job
                        </b-button>
                </b-col>
        </b-row>
    </div>
</template>
  
<script>
import DesiredPriorJobQuestion from '@/components/study/form/desired-job-profile/DesiredPriorJobQuestion';
export default {
    name: 'IcoInfoPopupContent',
    components: {
        DesiredPriorJobQuestion
    },
    props: {
        defaultQuestionData: Array
    },
    methods: {
        formatValue(value) {
            const nf = new Intl.NumberFormat('en-US');
            return nf.format(Math.floor(value));
        },
        goToDashBoard: function () {
            this.$emit('handle-go-to-dashboard');
        },
        icoInEditMode: function () {
            this.$emit('handle-ico-in-edit-mode');
        },
        createNewIcoMode: function () {
            this.$emit('handle-create-new-ico');
        }
    }
};
</script>
<style scoped>
.review-ico-btn{
    margin: 0 auto !important;
    display: flex !important;
    justify-content: center !important;
}
</style>

  